<template>
  <div>
    <div class="bg-content padding15">
      <el-form size="small" label-width="70px" ref="searchRef" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="公司名称">
              <el-select v-model="reqBody.companyId" placeholder="请选择" filterable @change="detail">
                <el-option
                  v-for="item in companies"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="padding15 bg-content">
      <el-transfer :data="permissionRes" v-model="reqBody.permissions" :titles="['未用有', '已拥有']" :props="{key:'id',label:'label'}"
                   :filterable="true"/>
      <div style="margin-top: 20px; margin-left: 45%;">
        <el-button type="primary" @click="update" size="small">更新</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 公司信息
      companies: [],
      // 所有资源
      permissionRes: [],
      reqBody: {
        companyId: null,
        permissions: []
      }
    };
  },
  methods: {
    update() {
      this.$confirm('您确定更新公司权限吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.loading('更新公司权限。。。');
        this.$ajax({
          method: 'POST',
          url: '/companyPermission/update',
          data: this.reqBody,
          prompt: true
        }).then(() => {
          loading.close();
        }).catch(() => {
          loading.close();
        });
      });
    },
    // 公司配置列表
    detail(companyId) {
      console.warn(`companyid:${companyId}`);
      this.reqBody.companyId = companyId;
      this.reqBody.permissions = [];
      const loading = this.loading('获取公司权限中。。。');
      this.$ajax({
        method: 'GET',
        url: `/companyPermission/detail/${companyId}`
      }).then((res) => {
        this.reqBody.permissions = res.data;
        loading.close();
      }).catch(() => {
        loading.close();
      });
    },
    // 公司列表
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companies = res.data;
        if (this.companies.length > 0) {
          this.reqBody.companyId = this.$account().companyId;
          this.detail(this.reqBody.companyId);
        }
      });
    },
    permissionList() {
      this.$ajax({
        method: 'GET',
        url: '/permission/list'
      }).then((res) => {
        res.data.forEach((temp) => {
          if (temp.disabled) {
            temp.label = `${temp.permissionName}(${temp.permissionCode})-不可编辑`;
          } else {
            temp.label = `${temp.permissionName}(${temp.permissionCode})`;
          }
        });
        this.permissionRes = res.data;
      });
    },
    loading(content) {
      return this.$loading({
        lock: true,
        text: content,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
  },
  mounted() {
    this.companyList();
    this.permissionList();
  },
  components: {
  }
};
</script>
<style>
  div.el-transfer .el-transfer-panel {
    width: 43%;
  }
  div.el-transfer .el-transfer-panel .el-transfer-panel__body {
    height: 450px;
  }
  div.el-transfer .el-transfer-panel .el-transfer-panel__body .el-transfer-panel__list {
    height: 398px;
  }
</style>




// WEBPACK FOOTER //
// src/page/main/permission/permissionPool.vue